import moment from 'moment';

const AssetDocumentPrint = ({ contentRef, formData, propertyList = [] }) => {
    // Format date helper function
    const formatDate = (date) => {
        return date && moment(date, "DD/MM/YYYY").isValid()
            ? moment(date, "DD/MM/YYYY").format("DD-MM-YYYY")
            : '';
    };

    const getPropertyNameById = (id) => {
        const property = propertyList.find(p => p.Id === id);
        return property ? property.Name : 'Unknown Property Id';
    };

    return (
        <div
            ref={contentRef}
            style={{
                padding: '10px',
                maxWidth: '800px',
                margin: '0 auto',
                backgroundColor: 'white',
                fontFamily: 'Arial, sans-serif',
                position: 'relative',
            }}
        >
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '8px' }}>
                <img
                    src="https://www.clanbridge.com/wp-content/uploads/2024/12/IMGL6317.jpg.webp"
                    height={90}
                    width={90}
                    alt="Image not found"
                    style={{ borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                />
                <span style={{ fontSize: '30px', color: '#635bff', fontWeight: 'bold' }}>
                    {getPropertyNameById(formData.PropId) || 'Property Not Found'}
                </span>
            </div>

            {/* Advice Details Table */}
            <div style={{ marginBottom: '20px' }}>
                <table
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        border: '1px solid #e5e7eb',
                    }}
                >
                    <thead>
                        <tr style={{ backgroundColor: '#635bff' }}>
                            <th
                                colSpan="4"
                                style={{
                                    fontSize: '20px',
                                    padding: '8px',
                                    border: '1px solid #e5e7eb',
                                    textAlign: 'left',
                                    color: 'white',
                                    fontWeight: 'bold',
                                }}
                            >
                                Asset Detail Documents
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr style={{ fontSize: '17px', backgroundColor: '#f9fafb' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Property
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {getPropertyNameById(formData.PropId) || 'Property Not Found'}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Asset DocNo
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.AssetDocNo || ''}
                            </td>
                        </tr>

                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Doc Date
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.AssetDocDt || ''}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Item Name
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.ItmName || ''}
                            </td>
                        </tr>

                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Bill No
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.BillNo || ''}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Bill Date
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.BillDt || ''}
                            </td>
                        </tr>

                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Brand
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.ModelBrand || ''}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Model No
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.ModelNo || ''}
                            </td>
                        </tr>

                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Colour
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.ModelColour || ''}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Class
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.ModelClass || ''}
                            </td>
                        </tr>

                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                OEM Part No
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.ModelOemPartNo || ''}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Quantity
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.Qty || ''}
                            </td>
                        </tr>

                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Rate
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.Rate || ''}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Balance Qty
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.BalQty || ''}
                            </td>
                        </tr>

                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Warranty Period
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.WarrantyPeriod || ''}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Warranty Upto
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.WarrantyUpto || ''}
                            </td>
                        </tr>

                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Service Provider
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.SerProvName || ''}
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>
                                Place
                            </td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                {formData.SerProvDtlName || 'N/A'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Footer at bottom of the page */}
            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: '20px',
                    right: 0,
                    backgroundColor: '#fff',
                    fontSize: '15px',
                    textAlign: 'left',
                    padding: '12px 0',
                }}
            >
                <p style={{ marginBottom: '4px' }}>
                    Thank you for choosing Clanbridge Living Pvt Ltd.
                </p>
                <p>For any queries, please contact: support@clanbridgeliving.in</p>
            </div>
        </div>
    );
};

export default AssetDocumentPrint;